import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<CreateSettings @poll={{@model}} />",{ moduleName: "@croodle/client/templates/create/settings.hbs" })